<template>
  <div>
    <FormComponent
      @searchForm="getFormData"
      :searchFormItem="formItem"
      :labelWidth="120"
      ref="FormComponent"
      :fileHidden="false"
      @handleReset="handleReset"
    >
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot1">
        <FormItem :label="$t('Talent Tag')"
          ><!-- 人才标签 -->
          <!-- <Select v-model="formItem.ability" clearable>
            <Option v-for="item in EmpAbility" :value="item.ch_value" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
          </Select> -->
          <Input v-model="formItem.ability" />
        </FormItem>
      </Col>
    </FormComponent>
    <Table
      border
      :loading="loading"
      :columns="columns"
      :data="data"
      style="margin:20px 0"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="checkBtn(row, index)"
        ></Button>
      </template>
      <template slot="empAbilityList" slot-scope="{ row }">
        <div style="display:flex;flex-wrap: wrap;">
          <Tag
            color="primary"
            v-for="(item, i) in row.empAbilityList"
            :key="i"
            v-if="item.flag == '1'"
            >{{ item.chValue }}</Tag
          >
        </div>
      </template>
      <template slot="talentmarkList" slot-scope="{ row }">
        <div style="display:flex;flex-wrap: wrap;">
          <Tag
            color="primary"
            v-for="(item, i) in row.talentmarkList"
            :key="i"
            v-if="item.flag == '1'"
            >{{ item.chValue }}</Tag
          >
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="action1">
        <Button
          type="primary"
          icon="ios-create"
          size="small"
          :disabled="row.isFlag == '0'"
          @click="assessmentClick(row, index), (showinfoModal = true)"
        ></Button>
      </template>
      <template slot-scope="{ row, index }" slot="beChinaKT" style="width:100%">
        <Checkbox
          v-model="row.beChinaKT"
          :disabled="row.isFlag == '0'"
          @on-change="targetItemChange(row, index, 'beChinaKT')"
        ></Checkbox>
      </template>
      <template slot-scope="{ row, index }" slot="beBuKT" style="width:100%">
        <Checkbox
          v-model="row.beBuKT"
          :disabled="row.isFlag == '0'"
          @on-change="targetItemChange(row, index, 'beBuKT')"
        ></Checkbox>
      </template>
      <template
        slot-scope="{ row, index }"
        slot="dirSupRemark"
        style="width:100%"
      >
        <Input
          type="textarea"
          :autosize="true"
          v-model="row.dirSupRemark"
          :disabled="row.isFlag == '0'"
          @on-change="targetItemChange(row, index, 'dirSupRemark')"
        ></Input>
      </template>
    </Table>
    <div
      style="margin:20px 0;display:flex; justify-content: flex-end;flex-direction: column; align-items: flex-end;"
    >
      <Page
        :total="total"
        :current="pageInfo.pageNo"
        :page-size="pageInfo.pageSize"
        transfer
        @on-change="pageChange"
        :page-size-opts="[10, 50, 100, 150]"
        show-sizer
        @on-page-size-change="pageSizeChange"
      />
      <div>
        <Button
          type="primary"
          style="margin-top:15px;margin-right:15px"
          @click="saveData"
          :disabled="loading || beEnd == 1 || beEnd == 4"
          ><!-- 保存 -->{{ $t("PB_Save") }}</Button
        >
        <Button
          type="primary"
          style="margin-top:15px;margin-right:15px"
          @click="exportData"
          :disabled="loading"
          ><!-- 导出 -->{{ $t("PB_Export") }}</Button
        >
        <Button
          type="primary"
          style="margin-top:15px"
          @click="returnPage"
          :disabled="loading"
          ><!-- 返回 -->{{ $t("Return") }}</Button
        >
      </div>
    </div>
    <Table
      border
      :columns="columnsExport"
      :data="dataExport"
      style="margin:20px 0"
      ref="table"
      v-show="false"
    ></Table>
    <Modal v-model="showinfoModal" title="评估" width="600px"
      ><!-- 评估 -->
      <Form :model="modalFormItem" label-position="left" :label-width="100">
        <FormItem label="人才类型"
          ><!-- 人才类型 -->
          <Select v-model="modalFormItem.abilityType" style="width:200px">
            <Option
              v-for="item in AbilityType"
              :value="item.ch_value"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem :label="$t('Talent Tag')"
          ><!-- 人才标签 -->
          <Transfer
            :data="data1"
            :target-keys="targetKeys"
            :render-format="render1"
            @on-change="handleChange1"
          ></Transfer>
        </FormItem>
        <FormItem :label="$t('PB_Comment')"
          ><!-- 备注说明 -->
          <Input type="textarea" v-model="modalFormItem.dirSupRemark"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button
          @click="(showinfoModal = false), (targetKeys = []), (data1 = [])"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
        <Button
          @click="
            save(), (showinfoModal = false), (targetKeys = []), (data1 = [])
          "
          ><!-- 确认 -->{{ $t("Confirm") }}</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import FormComponent from "../components/FormComponent.vue";
import axios from "axios";
import DateUtil from "@/util/DateUtil";
export default {
  components: { FormComponent },
  data() {
    return {
      date: new DateUtil(),
      prevent: false,
      formItem: {},
      searchItem: {},
      selectList: [],
      loading: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 150
      },
      total: 0,
      data: [],
      showinfoModal: false,
      modalFormItem: {},
      data1: [],
      targetKeys: [],
      tabName: "",
      EmpAbility: [],
      AbilityType: [],
      dataExport: [],
      id: "",
      beEnd: ""
    };
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("Check") /* 查看 */,
          slot: "action",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: this.lang == "zh" ? "department" : "enDepartment",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("Chinese_Name") /* 中文姓名 */,
          key: "userName",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("Position") /* 职位 */,
          key: this.lang == "zh" ? "position" : "enPosition",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: "dirSupName",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("Talent Tag") /* 人才标签 */,
          align: "center",
          minWidth: 380,
          children: [
            {
              slot: "talentmarkList",
              align: "center",
              minWidth: 200
            },
            {
              slot: "empAbilityList",
              align: "center",
              minWidth: 380
            }
          ]
        },
        {
          title: "China KT" /* China KT */,
          slot: "beChinaKT",
          align: "center",
          minWidth: 100
        },
        {
          title: "BU/FunctionKT" /* 是否BU KT */,
          slot: "beBuKT",
          align: "center",
          minWidth: 145
        },
        {
          title: this.$t("PB_Comment") /* 备注说明 */,
          slot: "dirSupRemark",
          align: "center",
          minWidth: 180
        }

        // ,{
        //   title: "评估",/* 评估 */
        //   slot: "action1",
        //   align: "center",
        //   minWidth: 100
        // }
      ];
    },
    columnsExport() {
      return [
        {
          title: this.$t("BU") /* 业务单元 */,
          key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: this.lang == "zh" ? "department" : "enDepartment",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("Chinese_Name") /* 中文姓名 */,
          key: "userName",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("Position") /* 职位 */,
          key: this.lang == "zh" ? "position" : "enPosition",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: "dirSupName",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("Talent Tag") /* 人才标签 */,
          key: "talentmark",
          align: "center",
          minWidth: 140
        },
        {
          title: this.$t("Talent Tag") /* 人才标签 */,
          key: "ability",
          align: "center",
          minWidth: 200
        },
        {
          title: "China KT" /* 是否China KT */,
          key: "beChinaKT",
          align: "center",
          minWidth: 140
        },
        {
          title: "BU/FunctionKT" /* 是否BU KT */,
          key: "beBuKT",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("PB_Comment") /* 备注说明 */,
          key: "dirSupRemark",
          align: "center",
          minWidth: 120
        }
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.FormComponent.levelDisabledState = true;
      this.$refs.FormComponent.levelDisabled = true;
      this.$refs.FormComponent.pShow = true;
    });
  },
  created() {},
  methods: {
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.$refs.FormComponent.positionList = res.positionList;
          this.$refs.FormComponent.departmentList = res.departmentList;
          this.$refs.FormComponent.businessUnitList = res.businessUnitList;
          this.$refs.FormComponent.salesAreaList = res.salesAreaList;
          this.$refs.FormComponent.YesOrNo = res.YesOrNo;
          this.$refs.FormComponent.BeQuit = res.BeQuit;
          this.$refs.FormComponent.salesAreaList = res.salesAreaList;
          this.$refs.FormComponent.Level = res.Level;
          this.EmpAbility = res.EmpAbility;
          this.AbilityType = res.AbilityType;
          this.$refs.FormComponent.functionList = res.functionList;
        }
      });
    },
    getFormData(item) {
      this.pageInfo.pageNo = 1;
      this.getData(item);
    },
    getData(item) {
      item ? (this.searchItem = JSON.parse(item)) : "";
      this.searchItem.year = "";
      let obj = {
        id: this.id,
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        ...this.pageInfo
      };
      this.loading = true;
      axios.post("/achEmpAbility/selectAchEmpAbility", obj).then(res => {
        if (res) {
          this.data = res.data;
          this.data.forEach((el, index) => {
            el.beChinaKT = !!+el.beChinaKT;
            el.beBuKT = !!+el.beBuKT;
          });
          this.total = parseInt(res.pageInfo.total);
        }
        this.$refs.FormComponent.prevent = false;
        this.loading = false;
      });
    },
    checkBtn(row, index) {
      let id = row.achApplyId == "" ? true : row.achApplyId;
      this.$router.push({
        path: "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27",
        query: { id: id, serialnumber: row.serialnumber }
      });
    },
    assessmentClick(row, index) {
      this.data1 = [];
      this.modalFormItem = JSON.parse(JSON.stringify(row));
      this.modalFormItem.empAbilityList.forEach((item, index) => {
        this.data1.push({
          ...item,
          key: item.code,
          label: item.chValue
        });
      });
      this.targetKeys = this.data1
        .filter(res => res.flag == "1")
        .map(item => item.key);
    },
    async save() {
      let array = [];
      await this.modalFormItem.empAbilityList.forEach((item, index) => {
        this.targetKeys.map(el => {
          if (el == item.code) {
            array.push(item);
          }
        });
      });
      this.modalFormItem.empAbilityList = array;
      await axios
        .post("/achEmpAbility/saveAchEmpAbility", this.modalFormItem)
        .then(res => {
          if (res) {
            this.$Message.success(res);
            this.getData(JSON.stringify(this.searchItem));
          }
        });
    },
    async saveData() {
      let array = JSON.parse(JSON.stringify(this.data));
      await array.forEach(el => {
        el.beChinaKT ? (el.beChinaKT = "1") : (el.beChinaKT = "0");
        el.beBuKT ? (el.beBuKT = "1") : (el.beBuKT = "0");
      });
      this.loading = true;
      axios.post("/achEmpAbility/saveAchEmpAbility", array).then(res => {
        this.loading = false;
        if (res) {
          this.$Message.success(res);
          this.getData(JSON.stringify(this.searchItem));
        }
      });
    },
    render1(item) {
      return item.label;
    },
    handleChange1(newTargetKeys) {
      this.targetKeys = newTargetKeys;
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      // this.getData(JSON.stringify(this.searchItem))
      this.saveData();
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.saveData();
    },
    exportData() {
      let obj = {
        id: this.id,
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        pageNo: 1,
        pageSize: 10000
      };
      this.loading = true;
      axios.post("/achEmpAbility/selectAchEmpAbility", obj).then(res => {
        this.loading = false;
        if (res) {
          this.dataExport = res.data;
          this.dataExport.forEach(el => {
            el.beChinaKT == "1" ? (el.beChinaKT = "是") : (el.beChinaKT = "否");
            el.beBuKT == "1" ? (el.beBuKT = "是") : (el.beBuKT = "否");
            el.ability = "";
            el.empAbilityList.forEach((item, i) => {
              el.ability += item.chValue + ",";
            });
          });
          this.$nextTick(() => {
            this.$exportExcel(
              "table",
              this.$t("Talent Tag") +
                this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm")
            );
          });
        }
      });
    },
    targetItemChange(row, index, key) {
      key && this.$set(this.data[index], key, row[`${key}`]);
    },
    returnPage() {
      this.$router.back();
    },
    handleReset() {
      this.formItem = {};
      // this.pageInfo.pageNo=1
      // this.getData(JSON.stringify(this.formItem))
    }
  }
};
</script>

<style lang="less" scoped>
.chartBox {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/.ivu-table-header thead tr:nth-child(2) {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PeopleBoardComponents/CapabilityAssessment.vue